import { t, useI18n } from "@bookingcom/lingojs-react";
import { useAirlinesCampaignPerformanceQuery } from "../../../hooks/useAirlinesCampaignPerformanceQuery";
import { useCampaignPerformanceQuery } from "../../../hooks/useCampaignPerformanceQuery";
import { useSelectedAirline } from "../../../hooks/useSelectedAirline";
import { useAuth } from "../../../hooks/useAuth";
import { ChartNoData } from "../ChartNoData";
import { AverageDiscountChart } from "./AverageDiscountChart";

export type AverageDiscountChartLoaderProps = {
  from: Date;
  to: Date;
};

export const AverageDiscountChartLoader = ({ from, to }: AverageDiscountChartLoaderProps) => {
  const i18n = useI18n();
  const { isAirlineUser } = useAuth();
  const useQuery = isAirlineUser ? useCampaignPerformanceQuery : useAirlinesCampaignPerformanceQuery;
  const { selectedAirline } = useSelectedAirline({ useSuspense: true });
  const { data: metrics } = useQuery({
    from,
    to,
    metrics: ["AVERAGE_DISCOUNT_PER_BOOKING", "AVERAGE_DISCOUNT_PERCENTAGE_PER_BOOKING"],
    airlineCode: selectedAirline?.code,
  });

  const averageDiscountInEuroMetric = metrics.find(
    (metric) => metric.metadata.metricName === "AVERAGE_DISCOUNT_PER_BOOKING"
  );
  const averageDiscountInPercentageMetric = metrics.find(
    (metric) => metric.metadata.metricName === "AVERAGE_DISCOUNT_PERCENTAGE_PER_BOOKING"
  );

  if (!averageDiscountInEuroMetric || !averageDiscountInPercentageMetric) {
    return <ChartNoData titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_name"))} />;
  }

  return (
    <AverageDiscountChart
      euroMetric={averageDiscountInEuroMetric}
      percentageMetric={averageDiscountInPercentageMetric}
    />
  );
};
